import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import FilterList, { FilterListProps } from 'core/Filters/FilterList';
import { keyBy, map, sortBy } from 'lodash';

export interface FilterReminderTypeProps extends Omit<FilterListProps, 'classes' | 'items' | 'allItems'> {}

const messages = defineMessages({
  appointment: {
    id: 'components.v2.FilterReminderType.appointment',
    defaultMessage: 'Appointment',
  },
  feedback: {
    id: 'components.v2.FilterReminderType.feedback',
    defaultMessage: 'Feedback',
  },
  referral: {
    id: 'components.v2.FilterReminderType.referral',
    defaultMessage: 'Referral',
  },
  outboundReferral: {
    id: 'components.v2.FilterReminderType.outboundReferral',
    defaultMessage: 'Outbound Referral',
  },
  followup: {
    id: 'components.v2.FilterReminderType.followup',
    defaultMessage: 'Follow-up',
  },
  patientForm: {
    id: 'components.v2.FilterReminderType.patientForm',
    defaultMessage: 'Patient Form',
  },
  recall: {
    id: 'components.v2.FilterReminderType.recall',
    defaultMessage: 'Recall',
  },
  telehealth: {
    id: 'components.v2.FilterReminderType.telehealth',
    defaultMessage: 'Telehealth',
  },
  waitingRoom: {
    id: 'components.v2.FilterReminderType.waitingRoom',
    defaultMessage: 'Waiting Room',
  },
});

const FilterReminderType: React.FC<FilterReminderTypeProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();

  const items: any[] = useMemo(
    () =>
      sortBy(
        map(messages, (value, id) => ({
          id,
          name: formatMessage(value),
        })),
        ['name'],
      ),
    [formatMessage],
  );
  const allItems = useMemo(() => keyBy(items, 'id'), [items]);

  return <FilterList items={items} allItems={allItems} {...rest} />;
};

export default FilterReminderType;
